import React from 'react';
import styled from 'styled-components';
import { DialogBase } from '@meettry/ui-components/components/atoms/DialogBase';
import { PrimaryButton } from '@meettry/ui-components/components/atoms/Button';
import { STYLE_TYPE } from '@meettry/ui-components/constants';
import { OnCloseType } from '@meettry/ui-components/types/dialog';

export const ErrorMessage: React.FC<OnCloseType> = (props) => {
  const { texts = [], onClose } = props;
  return (
    <StyledErrorMessage>
      <StyledErrorMessageContainer>
        {texts.map((text, i) =>
          text === '企業様向け画面へ' ? (
            <StyledErrorMessageLink
              href="https://enterprise.meettry.com/login"
              target="_blank"
              key={i}
            >
              {text}
            </StyledErrorMessageLink>
          ) : (
            <StyledErrorMessageText key={i}>{text}</StyledErrorMessageText>
          )
        )}
        <StyledErrorMessageButtons>
          <PrimaryButton size={STYLE_TYPE.SIZE.MEDIUM} onClick={onClose}>
            OK
          </PrimaryButton>
        </StyledErrorMessageButtons>
      </StyledErrorMessageContainer>
    </StyledErrorMessage>
  );
};

export default ErrorMessage;

const StyledErrorMessage = styled(DialogBase)`
  position: relative;
`;

const StyledErrorMessageContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const StyledErrorMessageText = styled.div`
  text-align: center;
  font-size: 16px;
  :not(:first-child) {
    margin-top: 10px;
  }
`;

const StyledErrorMessageLink = styled.a`
  display: block;
  text-align: center;
  font-size: 16px;
  margin-top: 40px;
  color: #0fafa9;
  cursor: pointer;
`;

const StyledErrorMessageButtons = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  & > * {
    max-width: 100px;
  }
`;
